import { render, staticRenderFns } from "./CustomRatingStars.vue?vue&type=template&id=7f96ea79&"
import script from "./CustomRatingStars.vue?vue&type=script&lang=js&"
export * from "./CustomRatingStars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports